import axios from 'axios'
import authService from '../services/auth.service'
import eventbus from '../util/eventbus'

const isAuthenticated = () => {
  let user = JSON.parse(localStorage.getItem('user'))
  return !!(user && user.token)
}

const authInterceptor = config => {
  if (isAuthenticated()) {
  // Set token for the following requests with Axios
    config.headers.common['authorization'] = `Bearer ${JSON.parse(localStorage.getItem('user')).token}`
  } else {
    // Remove token for the following requests with Axios
    config.headers.common['authorization'] = null
  }
  return config
}

const client = axios.create()

client.interceptors.request.use(authInterceptor)
client.interceptors.response.use((res) => {
  return res
}, (err) => {
  if (err.response && err.response.status && err.response.status === 401) {
    authService.logout()
    eventbus.$emit('on401')
  }
  return Promise.reject(err)
})

export default client